import { api } from './client'
import type { ApiResponse, PaginatedResponse } from '@/services/types/common'
import type { NodeTierListResp, NodeOrder, NodePurchaseReq } from '@/services/types/node'

export const nodeApi = {
  /** 节点档位列表（含剩余名额） */
  tiers: () => api.post<ApiResponse<NodeTierListResp>>('/node/tiers'),

  /** 购买节点 */
  purchase: (req: NodePurchaseReq) =>
    api.post<ApiResponse<NodeOrder>>('/node/purchase', req),

  /** 我的节点订单 */
  orders: (page = 1, size = 20) =>
    api.post<PaginatedResponse<NodeOrder>>('/node/orders', { page, size }),
}
